require('./RAModifyPlanView.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const classnames = require('classnames');
const moment = require('moment');
const Immutable = require('immutable');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKBreadcrumb } = require('commonsComponents/OKBreadcrumb');
const OKModal = require('components/commons/OKModal/OKModal');
const { OKCover } = require('commonsComponents/OKCover');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const RAPieChart = require('../../components/commons/RAPieChart/RAPieChart');
const RACover = require('../../components/commons/RACover/RACover');
const { OKMessage } = require('commonsComponents/OKMessage');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @components
const RAStrategyCards = require('../../components/RAStrategyCards/RAStrategyCards');
const RAComparativeTable = require('../../components/RAComparativeTable/RAComparativeTable');
const RACompareExpectedProfitability = require('../../components/RACompareExpectedProfitability/RACompareExpectedProfitability');
const RAGoalModifyPlanSummary = require('../../components/RAGoalSummary/RAGoalModifyPlanSummary');

// @actions
const brokerMyInvestments = require('actions/brokerMyInvestments');
const expectedProfitabilityActions = require('../../actions/RAExpectedProfitability');
const portfolioDistributionActions = require('../../actions/RAPortfolioDistribution');
const raManagementPlanActions = require('../../actions/RAManagementPlan');
const suitabilityActions = require('../../actions/RASuitabilityTest');
const raTimeHorizonCheck = require('../../actions/RATimeHorizonCheck');

// @utilites
const { formatText, FormattedText } = require('core/i18n').i18n;
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const {
    getCountAndUnitTerms,
} = require('../../utilities/RAObjectiveTrackingGetYearAndNoOfPoints');
const {
    recordProcess,
    PROC_RA_MODIFY_STRATEGY,
    PROC_START,
} = require('utilities/tagging');
const {
    getPorfolioOperationStatus,
} = require('../../utilities/RAStatusPortfolioOperationHelper');

// @constants
const { MYPROFILE_BROKER_URL } = require('constants/index');
const {
    RA_NO_STRATEGY_SELECTED,
    GOAL_TRACKING_URL,
    OBJECTIVE_TRACK_URL_PARA,
    PORTFOLIO_TRACKING_URL,
    PORTFOLIO_TRACK_URL_PARA,
    MYPROFILE_BROKER_ROBO_URL,
    DATE_FORMAT_TIME_HORIZON_CHECK,
} = require('../../raConstants/index');
const strategyText = {
    1: 'Kuala Lumpur',
    2: 'Shangai',
    3: 'Taipei',
    4: 'New York',
    5: 'Dubai',
};
const DATA_POINTS = 6;

// @Contact Center
const {
    PrinterPreviewManager,
} = require('components/contactCenter/printer/printerPreviewManager');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const riskTextByStrategy = {
    1: 'raStrategyItem-lowRisk',
    2: 'raStrategyItem-midLowRisk',
    3: 'raStrategyItem-midRisk',
    4: 'raStrategyItem-midHighRisk',
    5: 'raStrategyItem-highRisk',
};

class RAModifyPlanView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
        };

        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleProjectionChartYearsClick = this.handleProjectionChartYearsClick.bind(
            this,
        );
        this.handleNewStrategy = this.handleNewStrategy.bind(this);
        this.shortStrategyNumber = this.shortStrategyNumber.bind(this);
    }

    componentDidMount() {
        const {
            requestPortfolioDistribution,
            getTestResult,
            requestCurrentProjectionChart,
            immGlobalPosition,
            setDaysDiffrence,
            setTimeHorizonCheck,
            timeHorizonCheck,
            match: {
                params: { portfolioId },
            },
        } = this.props;

        const hasGoal = immGlobalPosition.getIn(
            ['portfolios', portfolioId, 'hasGoal'],
            false,
        );
        if (hasGoal) {
            const goalDate = immGlobalPosition.getIn(
                ['portfolios', portfolioId, 'goalInformation', 'goalDate'],
                '',
            );
            if (goalDate && !__CONTACT_CENTER__) {
                setDaysDiffrence(goalDate);
            } else {
                setTimeHorizonCheck(
                    moment(goalDate).format(DATE_FORMAT_TIME_HORIZON_CHECK),
                );
                timeHorizonCheck(false, this.shortStrategyNumber);
            }
        }
        requestPortfolioDistribution(portfolioId);
        getTestResult();
        requestCurrentProjectionChart({ portfolioId });

        const selectedStrategy = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'product',
            'typeOfProduct',
        ]);
        const customData = {
            processDetail: selectedStrategy,
        };
        this.modalOpen();
        recordProcess(PROC_RA_MODIFY_STRATEGY, PROC_START, customData);
    }

    componentWillUnmount() {
        this.props.resetManagement();
        this.props.resetPortfolio();
        this.props.resetExpectedProfitability();
    }

    showModal(tradingOnHold, strategyChange, monthlyRebalancing) {
        return (
            (tradingOnHold && !strategyChange) ||
            (tradingOnHold && strategyChange && !monthlyRebalancing)
        );
    }

    closeModal() {
        if (this.state.showModal) {
            this.setState({
                showModal: false,
            });
        }
    }

    modalOpen() {
        const {
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
            immPortfolioDistribution,
        } = this.props;

        const immPortfolioState = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'state',
        ]);
        const shouldShowModifyPlanModal = immPortfolioDistribution.get(
            'shouldShowModifyPlanModal',
        );

        if (shouldShowModifyPlanModal && immPortfolioState) {
            const tradingOnHold = immPortfolioState.get('tradingOnHold');
            const strategyChange = immPortfolioState.get('strategyChange');
            const monthlyRebalancing = immPortfolioState.get(
                'monthlyRebalancing',
            );

            if (
                this.showModal(
                    tradingOnHold,
                    strategyChange,
                    monthlyRebalancing,
                )
            ) {
                this.setState({
                    showModal: true,
                });
            }
        }
    }

    handleProjectionChartYearsClick(value) {
        const {
            immManagementPlan,
            immGlobalPosition,
            expectedProfitabilityChangeYears,
            requestCurrentProjectionChart,
            requestProjectionChart,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        expectedProfitabilityChangeYears(value);
        requestCurrentProjectionChart({ portfolioId });
        const balance = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'keyFigures',
            'valuation',
        ]);
        const currentProfile = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'product',
            'typeOfProduct',
        ]);
        const recurringContributionAmount = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'recurringTransfers',
            'amount',
        ]);
        const periodicity = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'recurringTransfers',
            'recurringCode',
        ]);
        const product = immManagementPlan.get('modifyPlanValue');
        if (currentProfile !== product) {
            requestProjectionChart({
                product,
                balance,
                freq: periodicity,
                mntPayment: recurringContributionAmount,
            });
        }
    }

    handleConfirm() {
        const {
            changeProduct,
            history,
            immManagementPlan,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const query = {
            typeOfProduct: immManagementPlan.get('modifyPlanValue'),
            portfolioId,
        };

        changeProduct(query, history);
    }

    shortStrategyNumber() {
        const { immTimeHorizonCheck, immManagementPlan } = this.props;
        const maxTypeOfProduct = immTimeHorizonCheck.get('maxTypeOfProduct');
        const selectedStrategy = immManagementPlan.get('modifyPlanValue');

        if (
            maxTypeOfProduct < selectedStrategy &&
            selectedStrategy !== RA_NO_STRATEGY_SELECTED
        ) {
            this.props.modifyStrategy(RA_NO_STRATEGY_SELECTED);
        }
    }

    buildStatePortfolioModal(
        tradingOnHold,
        strategyChange,
        monthlyRebalancing,
    ) {
        const {
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;

        const hasGoal = immGlobalPosition.getIn(
            ['portfolios', portfolioId, 'hasGoal'],
            false,
        );
        const hasGoalKey = hasGoal ? 'Goal' : 'Portfolio';

        const status = getPorfolioOperationStatus(
            tradingOnHold,
            strategyChange,
            monthlyRebalancing,
        );

        const titleKey = `raModifyPlan-modalOperationStatus_title${status}`;
        const contentKey = `raModifyPlan-modalOperationStatus_content${hasGoalKey}${status}`;
        const buttonTextKey = `raModifyPlan-modalOperationStatus_buttonText${status}`;

        const modalButton = (
            <OKButton onClick={() => this.closeModal()}>
                <FormattedText value={buttonTextKey} />
            </OKButton>
        );
        return (
            <OKModal
                title={formatText(titleKey)}
                titleAlignment="center"
                content={contentKey}
                footerType="action"
                isOpen={this.state.showModal}
                onPrimaryButtonClick={() => this.closeModal()}
                onCloseCallback={() => this.closeModal()}
                primaryButtonCustom={modalButton}
            />
        );
    }

    buildModalExtraInfoContactCenterOffice() {
        if (!isPrintOfficeMode()) {
            return null;
        }

        const {
            immSuitabilityTest,
            immGlobalPosition,
            immManagementPlan,
            match: {
                params: { portfolioId },
            },
        } = this.props;

        const investProfileDescription = immSuitabilityTest.getIn(
            ['results', 0, 'clientRiskProfileTitle'],
            '',
        );
        const currentStrategyCode = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'product',
            'typeOfProduct',
        ]);
        const currentStrategyText = strategyText[currentStrategyCode];
        const currentStrategyRisk = formatText(
            riskTextByStrategy[currentStrategyCode],
        );
        const newStrategyCode = immManagementPlan.get('modifyPlanValue');
        const newStrategyText = strategyText[newStrategyCode];
        const newStrategyRisk = formatText(riskTextByStrategy[newStrategyCode]);

        return (
            <div className="ra-modify-plan-view-modal-info-cc">
                <div className="ra-modify-plan-view-modal-info-cc__profile-container print-label">
                    <FormattedText
                        className="ra-modify-plan-view-modal-info-cc__profile"
                        value="raModifyPlan-modalProfile"
                    />
                    <span className="ra-modify-plan-view-modal-info-cc__profile ra-modify-plan-view-modal-info-cc__profile--bold">
                        {investProfileDescription}
                    </span>
                </div>
                <div className="ra-modify-plan-view-modal-info-cc__strategies-container">
                    <div className="ra-modify-plan-view-modal-info-cc__current-strategy-container print-paragraph">
                        <FormattedText
                            className="ra-modify-plan-view-modal-info-cc__strategy ra-modify-plan-view-modal-info-cc__strategy--bold"
                            value="raModifyPlan-modalCurrent"
                        />
                        <div className="ra-modify-plan-view-modal-info-cc__current-strategy">
                            <div>
                                <FormattedText
                                    className="ra-modify-plan-view-modal-info-cc__strategy"
                                    value="raModifyPlan-modalStrategy"
                                />
                                <span className="ra-modify-plan-view-modal-info-cc__strategy ra-modify-plan-view-modal-info-cc__strategy--bold">
                                    {currentStrategyText}
                                </span>
                            </div>
                            <div>
                                <span className="ra-modify-plan-view-modal-info-cc__strategy ra-modify-plan-view-modal-info-cc__strategy--bold">
                                    {currentStrategyRisk}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="ra-modify-plan-view-modal-info-cc__new-strategy-container">
                        <FormattedText
                            className="ra-modify-plan-view-modal-info-cc__strategy ra-modify-plan-view-modal-info-cc__strategy--bold"
                            value="raModifyPlan-modalNew"
                        />
                        <div className="ra-modify-plan-view-modal-info-cc__new-strategy">
                            <div>
                                <FormattedText
                                    className="ra-modify-plan-view-modal-info-cc__strategy"
                                    value="raModifyPlan-modalStrategy"
                                />
                                <span className="ra-modify-plan-view-modal-info-cc__strategy ra-modify-plan-view-modal-info-cc__strategy--bold">
                                    {newStrategyText}
                                </span>
                            </div>
                            <div>
                                <span className="ra-modify-plan-view-modal-info-cc__strategy ra-modify-plan-view-modal-info-cc__strategy--bold">
                                    {newStrategyRisk}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ra-modify-plan-view-modal-info-cc__print-button-container">
                    <PrinterPreviewManager titleOverrider="raModifyPlan-modalPrintTitle" />
                </div>
            </div>
        );
    }

    buildPieChart(immAssetAllocations = Immutable.fromJS([])) {
        const assetAllocationsDonutData = immAssetAllocations.map(asset => ({
            key: asset.get('assetClassId'),
            label: asset.get('assetClass'),
            value: asset.get('weight'),
        }));

        return (
            <div className="ra-modify-plan-view__pie-chart">
                <RAPieChart data={assetAllocationsDonutData} />
            </div>
        );
    }

    buildSecondChartLabel(isChartDisabled, investProfileCard) {
        let content;
        if (isChartDisabled) {
            content = (
                <div className="ra-modify-plan-view__pie-chart-inactive-label">
                    <FormattedText value="raModifyPlan-inactiveChartLabel" />
                </div>
            );
        } else {
            content = (
                <div className="ra-modify-plan-view__pie-chart-label">
                    <FormattedTextWithComponents
                        value="raModifyPlan-raModifyPlan_walletChartLabel"
                        injectedComponents={[strategyText[investProfileCard]]}
                    />
                </div>
            );
        }

        return content;
    }

    handleNewStrategy(evt) {
        const {
            immGlobalPosition,
            modifyStrategy,
            requestProjectionChart,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const currentProfile = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'product',
            'typeOfProduct',
        ]);
        const originalPortfolio = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
        ]);
        const recurringContributionAmount = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'recurringTransfers',
            'amount',
        ]);
        const periodicity = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'recurringTransfers',
            'recurringCode',
        ]);
        modifyStrategy(currentProfile, evt, originalPortfolio);

        if (evt !== currentProfile) {
            const balance = immGlobalPosition.getIn([
                'portfolios',
                portfolioId,
                'keyFigures',
                'valuation',
            ]);
            const product = evt;
            requestProjectionChart({
                dataPoints: DATA_POINTS,
                product,
                balance,
                freq: periodicity,
                mntPayment: recurringContributionAmount,
            });
        }
    }

    buildGoalSummary(immGlobalPositionPortfolio, hasGoal) {
        if (hasGoal) {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="ra-modify-plan-view__inversion-profile-title">
                            <FormattedText value="raHireManagementPlanSuccess-raHireManagementPlanSuccess_goalTitle" />
                        </h2>
                        <div className="ra-modify-plan-view__section-gbi">
                            <RAGoalModifyPlanSummary
                                immGlobalPositionPortfolio={
                                    immGlobalPositionPortfolio
                                }
                            />
                        </div>
                    </div>
                </div>
            );
        }
    }

    buildTitleSection(hasGoal) {
        const profileTitle = hasGoal
            ? 'raModifyPlan-raModifyPlan_investmentProfileWithGoal'
            : 'raModifyPlan-investmentProfile';
        const profileSubtitle = hasGoal
            ? 'raModifyPlan-raModifyPlan_disclaimerWithGoal'
            : 'raModifyPlan-disclaimer1';
        return (
            <div>
                <div className="ra-modify-plan-view__inversion-profile-title">
                    <FormattedText value={profileTitle} />
                </div>
                <div className="ra-modify-plan-view__inversion-profile-info-container">
                    <FormattedText value={profileSubtitle} />
                    <FormattedText value="raModifyPlan-disclaimer2" />
                </div>
            </div>
        );
    }

    buildStatePortfolioDisclaimer(hasGoal) {
        const disclaimerKey = hasGoal
            ? 'raModifyPlan-raModifyPlan_noOrderNoRebalancingGoalMessage'
            : 'raModifyPlan-raModifyPlan_noOrderNoRebalancingPortfolioMessage';
        const disclaimerMessage = formatText(disclaimerKey);

        return __CONTACT_CENTER__ ? (
            <BlockInfo>{disclaimerMessage}</BlockInfo>
        ) : (
            <OKMessage>{disclaimerMessage}</OKMessage>
        );
    }

    buildModifyPlanView(
        investProfileCard,
        investProfileSimulation,
        isDisabled,
    ) {
        const {
            immManagementPlan,
            immPortfolioDistribution,
            immExpectedProfitability,
            immGlobalPosition,
            immTimeHorizonCheck,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const hasGoal = immGlobalPosition.getIn(
            ['portfolios', portfolioId, 'hasGoal'],
            false,
        );
        const maxInvestProfileValue = hasGoal
            ? immGlobalPosition.getIn([
                  'portfolios',
                  portfolioId,
                  'goalInformation',
                  'maxTypeOfProduct',
              ])
            : immGlobalPosition.getIn([
                  'portfolios',
                  portfolioId,
                  'product',
                  'maxTypeOfProduct',
              ]);
        const immComparative = immPortfolioDistribution.getIn([
            'comparative',
            `${investProfileSimulation}-${investProfileCard}`,
        ]);
        const secondChartLabel = this.buildSecondChartLabel(
            isDisabled,
            investProfileCard,
        );
        const chartYears = immExpectedProfitability.get('chartYears');
        const currentProductsChartData = immExpectedProfitability.get(
            'currentChartData',
        );
        const productsChartData = immExpectedProfitability.get('chartData');
        const daysDiff = immExpectedProfitability.get('daysDiff');
        const noOfChartPoints = immExpectedProfitability.get('noOfChartPoints');
        const tickInfo = getCountAndUnitTerms(daysDiff, noOfChartPoints);

        const currentProbability = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'hasGoal',
        ])
            ? immGlobalPosition.getIn([
                  'portfolios',
                  portfolioId,
                  'goalInformation',
                  'probability',
              ])
            : null;

        let strategyContent, currentChartData, comparedProductChartData;

        if (productsChartData) {
            comparedProductChartData = productsChartData.toJS();
        }

        if (currentProductsChartData) {
            currentChartData = currentProductsChartData.toJS();
        }
        const newPortfolio = investProfileCard && investProfileCard.toString();
        const immOriginAssetAllocations = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'assetAllocation',
        ]);
        let immNewAssetAllocations;
        if (investProfileSimulation !== investProfileCard) {
            immNewAssetAllocations = immPortfolioDistribution.getIn([
                'portfolio',
                newPortfolio,
                'assetAllocations',
            ]);
        }

        const originProfilePieChart = this.buildPieChart(
            immOriginAssetAllocations,
        );
        const newProfilePieChart = this.buildPieChart(immNewAssetAllocations);

        if (
            immManagementPlan.get('isFetchingInvestProfile') ||
            immTimeHorizonCheck.get('isFetching') ||
            immPortfolioDistribution.get('isFetching')
        ) {
            strategyContent = <LoadingSection />;
        } else {
            strategyContent = (
                <RAStrategyCards
                    maxAvailable={maxInvestProfileValue}
                    modifyPlan={true}
                    firstCardSelected={investProfileSimulation}
                    selectedCard={investProfileCard}
                    selectStrategy={this.handleNewStrategy} // eslint-disable-line
                />
            );
        }

        let goalSummary = this.buildGoalSummary(
            immGlobalPosition.getIn(['portfolios', portfolioId]),
            hasGoal,
        );
        const goalAmount = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'goalInformation',
            'goalAmount',
        ]);
        const actualAmount = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'keyFigures',
            'valuation',
        ]);
        const profileTitleSection = this.buildTitleSection(hasGoal);
        const cancelURL = hasGoal
            ? `${GOAL_TRACKING_URL}/${portfolioId}`
            : `${PORTFOLIO_TRACKING_URL}/${portfolioId}`;

        const immState = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'state',
        ]);
        const tradingOnHold = immState.get('tradingOnHold');
        const strategyChange = immState.get('strategyChange');
        const monthlyRebalancing = immState.get('monthlyRebalancing');
        const stateWalletDisclaimer =
            !tradingOnHold && !strategyChange && !monthlyRebalancing
                ? this.buildStatePortfolioDisclaimer(hasGoal)
                : null;

        let modalSection;
        modalSection = this.showModal(
            tradingOnHold,
            strategyChange,
            monthlyRebalancing,
        )
            ? this.buildStatePortfolioModal(
                  tradingOnHold,
                  strategyChange,
                  monthlyRebalancing,
              )
            : null;
        return (
            <div>
                <div className="row ra-modify-plan-view__container--salmon">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            {goalSummary}
                            {modalSection}
                            <div className="row">
                                <div className="col-md-12">
                                    {profileTitleSection}
                                    <div className="ra-modify-plan-view__strategy-content">
                                        {strategyContent}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <RACompareExpectedProfitability
                                        changeYears={ // eslint-disable-line
                                            this.handleProjectionChartYearsClick
                                        }
                                        currentChartData={currentChartData}
                                        comparedChartData={
                                            comparedProductChartData
                                        }
                                        comparedProfile={investProfileCard}
                                        currentProfile={investProfileSimulation}
                                        currentProbability={currentProbability}
                                        chartYears={chartYears}
                                        loading={immExpectedProfitability.get(
                                            'isFetching',
                                        )}
                                        isDisabled={isDisabled}
                                        hasGoal={hasGoal}
                                        goalAmount={goalAmount}
                                        actualAmount={actualAmount}
                                        tickInfo={tickInfo}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row ra-modify-plan-view__container--light-salmon">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <h2 className="ra-modify-plan-view__section-title">
                                        <FormattedText value="raModifyPlan-comparativeTitle" />
                                    </h2>
                                </div>
                            </div>
                            <div className="row ra-modify-plan-view__section-pie-charts">
                                <div className="col-md-4">
                                    <div className="ra-modify-plan-view__section-crop-info">
                                        <FormattedText
                                            className="ra-modify-plan-view__section-info"
                                            value="raModifyPlan-comparativeInfo"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 col-md-offset-2">
                                    <div className="ra-modify-plan-view__pie-charts">
                                        {originProfilePieChart}
                                        {newProfilePieChart}
                                    </div>
                                </div>
                            </div>
                            <div className="row no-gutter ra-modify-plan-view__section-distributions">
                                <div className="col-md-6">
                                    <div className="ra-modify-plan-view__section-subtitle">
                                        <FormattedText value="raModifyPlan-distributionDetailTitle" />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="ra-modify-plan-view__pie-chart-label">
                                        <FormattedTextWithComponents
                                            value="raModifyPlan-raModifyPlan_walletChartLabel"
                                            injectedComponents={[
                                                strategyText[
                                                    investProfileSimulation
                                                ],
                                            ]}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3 ra-modify-plan-view__pie-chart-wrap">
                                    {secondChartLabel}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="ra-modify-plan-view__section-table">
                                        <RAComparativeTable
                                            immComparative={immComparative}
                                        />
                                        {stateWalletDisclaimer}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row ra-modify-plan-view__container--blue">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12 ra-modify-plan-view__footer">
                                    <div>
                                        <OKLink
                                            inverse={true}
                                            modifier="complementary"
                                            to={cancelURL}
                                        >
                                            <FormattedText value="raModifyPlan-cancelButton" />
                                        </OKLink>
                                    </div>
                                    <div className="ra-modify-plan-view__footer-icon-group">
                                        <div>
                                            <i className="ra-modify-plan-view__footer-icon icon-advertencia" />
                                            <span className="ra-modify-plan-view__footer-icon-text">
                                                <FormattedText value="raModifyPlan-raModifyPlan_rebalancingMessage" />
                                            </span>
                                        </div>
                                        <OKButton
                                            onClick={this.handleConfirm}
                                            disabled={isDisabled}
                                        >
                                            <FormattedText value="raModifyPlan-ctaButton" />
                                        </OKButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    prepareBreadcrumb() {
        const {
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const origin = immGlobalPosition.get('originRedirection');
        let parentTitle;
        let parentUrl;
        if (origin === PORTFOLIO_TRACK_URL_PARA) {
            parentTitle = formatText(
                'raPortfolioTracking-raPortfolioTracking_breadcrumbThird',
            );
            parentUrl = `${PORTFOLIO_TRACKING_URL}/${portfolioId}`;
        } else if (origin === OBJECTIVE_TRACK_URL_PARA) {
            parentTitle = formatText('breadcrumb-breadcrumb_objectiveTracking');
            parentUrl = `${GOAL_TRACKING_URL}/${portfolioId}`;
        }

        return [
            {
                text: formatText('raManagementPlan-investments'),
                url: MYPROFILE_BROKER_URL,
            },
            {
                text: formatText('raModifyPlan-raModifyPlan_investBreadcrumb'),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            ...(origin === PORTFOLIO_TRACK_URL_PARA ||
            origin === OBJECTIVE_TRACK_URL_PARA
                ? [
                      {
                          text: parentTitle,
                          url: parentUrl,
                      },
                  ]
                : []),
            {
                text: formatText('raModifyPlan-raModifyPlan_modifyBreadcrumb'),
                url: '',
            },
        ];
    }

    buildModifyPlanViewHeader(isDisabled) {
        const mappingBreadcrumb = this.prepareBreadcrumb();
        const investProfileDescription = this.props.immSuitabilityTest.getIn(
            ['results', 0, 'clientRiskProfileTitle'],
            '',
        );

        return (
            <div className="row">
                <OKCover size="medium" section="broker" customClass="col-xs-12">
                    <div className="ra-modify-plan-view__header">
                        <div className="ra-modify-plan-view__header-breadcrumb">
                            <OKBreadcrumb mapping={mappingBreadcrumb} />
                        </div>
                        <div className="ra-modify-plan-view__header-title">
                            <FormattedText value="raModifyPlan-title" />
                        </div>
                        <div className="ra-modify-plan-view__header-extra-content">
                            <div className="ra-modify-plan-view__header-profile">
                                <div>
                                    <FormattedText
                                        value="raManagementPlan-inversorProfile"
                                        className="ra-modify-plan-view__header-profile-label"
                                    />
                                </div>
                                <div className="ra-modify-plan-view__header-profile-type">
                                    {investProfileDescription}
                                </div>
                            </div>
                            <div className="ra-modify-plan-view__header-description">
                                <FormattedText value="raModifyPlan-headerDescription" />
                            </div>
                            <div className="ra-modify-plan-view__header-button">
                                <OKButton
                                    onClick={this.handleConfirm}
                                    disabled={isDisabled}
                                >
                                    <FormattedText value="raModifyPlan-ctaButton" />
                                </OKButton>
                            </div>
                        </div>
                    </div>
                </OKCover>
            </div>
        );
    }

    buildChangeProductSuccessHeader() {
        const breadcrumb = this.prepareBreadcrumb();
        const submitSuccessful = true;

        return (
            <div className="row">
                <RACover
                    breadcrumb={breadcrumb}
                    success={submitSuccessful}
                    successTitle={formatText(
                        'raModifyPlan-raModifyPlan_headerSuccessTitle',
                    )}
                    sectionName="broker"
                    goalType="broker"
                />
            </div>
        );
    }

    buildContentBox(buildingCity, profileType) {
        const iconClassName = classnames(
            'ra-modify-plan-view__icon-product',
            `ra-modify-plan-view__icon-product--${buildingCity}`,
        );
        const buildingCityName = formatText(
            `raStrategyItem-raStrategyItem_${buildingCity}`,
        );

        return (
            <div className="ra-modify-plan-view__success-content-block">
                <div className={iconClassName} />
                <FormattedText
                    value={`raCompareProfitability-${profileType}`}
                />
                <div className="ra-modify-plan-view__success-content-block-label">
                    {buildingCityName}
                </div>
            </div>
        );
    }

    buildChangeProductSuccessView(investProfileCard, investProfileSimulation) {
        const firstBulidingBlock = this.buildContentBox(
            investProfileSimulation,
            'currentProfile',
        );
        const changedBulidingBlock = this.buildContentBox(
            investProfileCard,
            'newProfile',
        );

        return (
            <div className="row ra-modify-plan-view__success grid-view--fix-cell-separation">
                <div className=" ra-modify-plan-view__success-container ra-modify-plan-view__container--white ">
                    <div className="ra-modify-plan-view__success-content">
                        {firstBulidingBlock}
                        <div className="ra-modify-plan-view__success-content-block">
                            <div className="ra-modify-plan-view__success-content-block-arrow">
                                <i className="ra-modify-plan-view__success-content-block-icon icon-flecha-izquierda" />
                            </div>
                        </div>
                        {changedBulidingBlock}
                    </div>
                    <div className="ra-modify-plan-view__success-content-footer ra-modify-plan-view__container--light-salmon">
                        <div className="ra-modify-plan-view__success-content-footer-text">
                            <FormattedText value="raModifyPlan-raModifyPlan_successMessage" />
                        </div>
                    </div>
                </div>
                <div className="ra-modify-plan-view__success-navigation-section ra-modify-plan-view__container--salmon ">
                    <OKButton
                        to={MYPROFILE_BROKER_ROBO_URL}
                        modifier="secondary"
                    >
                        <FormattedText value="raHireManagementPlanSuccess-raHireManagementPlanSuccess_ctaButton" />
                    </OKButton>
                </div>
            </div>
        );
    }

    render() {
        const {
            immManagementPlan,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const investProfileSimulation = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'product',
            'typeOfProduct',
        ]);

        const investProfileCard =
            immManagementPlan.get('modifyPlanValue') || investProfileSimulation;
        const isChangingProductSuccess = immManagementPlan.get(
            'isChangingProductSuccess',
        );
        const isDisabled = investProfileCard === investProfileSimulation;
        const modifyPlanViewHeader = isChangingProductSuccess
            ? this.buildChangeProductSuccessHeader()
            : this.buildModifyPlanViewHeader(isDisabled);
        const modifyPlanViewContent = isChangingProductSuccess
            ? this.buildChangeProductSuccessView(
                  investProfileCard,
                  investProfileSimulation,
              )
            : this.buildModifyPlanView(
                  investProfileCard,
                  investProfileSimulation,
                  isDisabled,
              );

        return (
            <div className="ra-modify-plan-view grid-view">
                <div className="container-fluid">{modifyPlanViewHeader}</div>
                <div className="container-fluid">{modifyPlanViewContent}</div>
            </div>
        );
    }
}

RAModifyPlanView.propTypes = {
    changeProduct: PropTypes.func.isRequired,
    expectedProfitabilityChangeYears: PropTypes.func.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    getTestResult: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immCheckStatus: PropTypes.object.isRequired,
    immExpectedProfitability: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immManagementPlan: PropTypes.object.isRequired,
    immPortfolioDistribution: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immSuitabilityTest: PropTypes.object.isRequired,
    immTimeHorizonCheck: PropTypes.object.isRequired,
    modifyProfile: PropTypes.func.isRequired,
    modifyStrategy: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    requestComparedProjectionChart: PropTypes.func.isRequired,
    requestCurrentProjectionChart: PropTypes.func.isRequired,
    requestInvestmentProfile: PropTypes.func.isRequired,
    requestPortfolioDistribution: PropTypes.func.isRequired,
    requestProjectionChart: PropTypes.func.isRequired,
    resetManagement: PropTypes.func.isRequired,
    resetPortfolio: PropTypes.func.isRequired,
    resetExpectedProfitability: PropTypes.func.isRequired,
    saveSimulation: PropTypes.func.isRequired,
    setDaysDiffrence: PropTypes.func.isRequired,
    setOrigin: PropTypes.func.isRequired,
    setTimeHorizonCheck: PropTypes.func.isRequired,
    timeHorizonCheck: PropTypes.func.isRequired,
    updateInitialContributionInput: PropTypes.func.isRequired,
    updateInitialContributionSlider: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immBrokerMyInvestments: state.brokerMyInvestments,
        immCheckStatus: state.raCheckStatus,
        immExpectedProfitability: state.raExpectedProfitability,
        immGlobalPosition: state.raGlobalPosition,
        immManagementPlan: state.raManagementPlan,
        immPortfolioDistribution: state.raPortfolioDistribution,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immSuitabilityTest: state.raSuitabilityTest,
        immTimeHorizonCheck: state.raTimeHorizonCheck,
    }),
    {
        changeProduct: raManagementPlanActions.changeProduct,
        getTestResult: suitabilityActions.getTestResult,
        expectedProfitabilityChangeYears:
            expectedProfitabilityActions.changeYears,
        fetchMyInvestments: brokerMyInvestments.fetchMyInvestments,
        modifyProfile: raManagementPlanActions.modifyProfile,
        modifyStrategy: raManagementPlanActions.modifyStrategy,
        requestCurrentProjectionChart:
            expectedProfitabilityActions.requestCurrentProjectionChart,
        requestInvestmentProfile:
            raManagementPlanActions.requestInvestmentProfile,
        requestPortfolioDistribution:
            portfolioDistributionActions.requestPortfolioDistribution,
        requestProjectionChart:
            expectedProfitabilityActions.requestProjectionChart,
        resetManagement: raManagementPlanActions.reset,
        resetPortfolio: portfolioDistributionActions.resetPortfolio,
        resetExpectedProfitability:
            expectedProfitabilityActions.resetExpectedProfitability,
        saveSimulation: raManagementPlanActions.saveSimulation,
        setDaysDiffrence: expectedProfitabilityActions.setDaysDiffrence,
        setOrigin: suitabilityActions.setOrigin,
        setTimeHorizonCheck: raTimeHorizonCheck.setTimeHorizonCheck,
        timeHorizonCheck: raTimeHorizonCheck.timeHorizonCheck,
        updateInitialContributionInput:
            raManagementPlanActions.updateInitialContributionInput,
        updateInitialContributionSlider:
            raManagementPlanActions.updateInitialContributionSlider,
    },
)(withRouter(RAModifyPlanView));
